import Icon, { IconSize } from "@vfuk/core-icon";
import type { IconProps } from "@vfuk/core-icon";
import { CSSProperties } from "react";

type InteractiveIconProps = IconProps & {
  onClick: React.MouseEventHandler<HTMLDivElement>;
  disabled?: boolean;
  size?: IconSize;
  isTiny?: boolean;
};

const disabledStyles: CSSProperties = {
  pointerEvents: "none",
  opacity: 0.4,
  userSelect: "none",
};

const InteractiveIcon = ({
  name,
  group,
  onClick,
  disabled = false,
  isTiny = false,
  size,
}: InteractiveIconProps) => (
  <div
    onClick={onClick}
    style={{
      ...(disabled ? disabledStyles : undefined),
      ...(isTiny ? { maxHeight: "15px" } : undefined),
    }}
  >
    <Icon name={name} group={group} size={size} />
  </div>
);

export default InteractiveIcon;
